<template>
  <div class="navbar navbar-expand-lg">
    <router-link class="navbar-brand" to="/"><img class="home-icon" src="../assets/icWwwLogo.png" alt="home-icon"/></router-link>
    <button
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#navbarNavAltMarkup"
      aria-controls="navbarNavAltMarkup"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarNavAltMarkup">
      <div class="navbar-nav ml-auto">
        <router-link to="/admin/hello" class="nav-item nav-link nav-btn-wwaw">Hello</router-link>
        <div class="pl-3 pr-3"></div>
        <router-link to="/admin/users" class="nav-item nav-link nav-btn-wwaw">Users</router-link>
        <div class="pl-3 pr-3"></div>
        <router-link to="/admin/outfits" class="nav-item nav-link nav-btn-wwaw">Outfits</router-link>
        <div class="pl-3 pr-3"></div>
        <router-link to="/admin/articles" class="nav-item nav-link nav-btn-wwaw">Articles</router-link>
        <div class="pl-3 pr-3"></div>
        <button @click="logout" class="nav-item nav-link nav-btn-wwaw">Logout</button>
      </div>
    </div>
  </div>
</template>

<script>
import {auth} from '../firebaseConfig'
export default {
  name: "AdminNav",
  data() {
    return {};
  },
  mounted () {
    // From testing, without a brief timeout, it won't work.

  },
  methods: {
    logout: function() {
      auth.signOut().then(() => {
        this.$router.replace('/admin/login');
      })
    }
  }
};
</script>

<style scoped>
.navbar {
  background-color: #FFFFFF !important;
  margin-bottom: 0px;
  padding: 16px;
  border-bottom:#d3d3d3 1px solid;
}
.home-icon{
  width:50px;
}
.nav-item {
  color: #000000;
}
.nav-btn-wwaw {
  /* Rectangle 2: */
  border: 1px solid #29c4d5;
  border-radius: 18px;
  height: 33px;
  width: 95px;
  line-height: 16px;
}
.nav-btn-wwaw-ns {
  color: white;
  height: 33px;
  width: 95px;
  line-height: 16px;
}
</style>
